import classNames from 'helpers/class-names'
import { FC, HTMLProps, ReactNode } from 'react'

interface Props extends HTMLProps<HTMLSpanElement> {
  className?: string
  children: ReactNode
}

export const Badge: FC<Props> = ({ children, className, ...props }) => (
  <span
    className={classNames(
      'rounded-full bg-gray-200 px-2 text-sm font-semibold text-white',
      className,
    )}
    {...props}>
    {children}
  </span>
)
